export default "__VITE_ASSET__a0b43891__"